import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import maintenance_45global from "/app/middleware/maintenance.global.ts";
import redirect_45global from "/app/middleware/redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  maintenance_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}